module.exports = __webpack_public_path__ + "img/economy-panel-outline.15158615.svg";